import { supabase } from "./supabase";

/**
 * apiFetch — fetch wrapper that attaches the logged-in user's Supabase session
 * token as `Authorization: Bearer <token>`. Use this for any /api/* endpoint
 * that authorizes the caller (e.g. the trigger endpoints gated behind
 * CRON_SECRET + user-JWT). Falls back to a plain fetch if there's no session.
 */
export async function apiFetch(url, options = {}) {
  let token = null;
  try {
    token = (await supabase.auth.getSession())?.data?.session?.access_token || null;
  } catch { /* no session — send unauthenticated */ }
  const headers = { ...(options.headers || {}) };
  if (token && !headers.Authorization) headers.Authorization = `Bearer ${token}`;
  return fetch(url, { ...options, headers });
}
